<template>
  <div class="body-main-container">
    <div class="login-stage-container">
      <div class="login-main-container">
        <div class="imagelogin-container">
          <img
            src="../assets/loginimage.webp"
            alt="Imagen de Login"
            style="
              width: 100%;
              height: 100%;
              border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;
              filter: brightness(90%) contrast(105%);
              object-fit: cover;
            "
          />
        </div>
        <div class="contentmain-container">
          <div class="d-flex align-items-center mb-4">
            <img
              src="../assets/logobaessh.svg"
              alt="Logo Baessh"
              style="width: 3rem; margin-right: 0.5rem"
            />
            <span class="brand-text font-weight-light" style="font-size: 1.5rem"
              >BAESSH</span
            >
          </div>
          <div class="login-message-container mb-4">
            <div class="alert alert-danger login-error-message" role="alert" v-if="errorMessage">
              {{ errorMessage }}
              <div v-if="lockedCountdown" class="login-error-countdown">
                Intenta nuevamente en {{ lockedCountdown }}.
              </div>
            </div>
            <span v-else>Iniciar Sesión</span>
          </div>
          <form @submit.prevent="iniciarSesion()">
            <div class="input-group mb-3">
              <input
                id="rfc"
                type="text"
                class="form-control"
                name="rfc"
                v-model="rfc"
                required
                autocomplete="rfc"
                autofocus
                placeholder="Usuario"
              />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fa fa-user" style="font-size: 18px"></span>
                </div>
              </div>
            </div>
            <div class="input-group mb-4">
              <input
                id="password"
                type="password"
                class="form-control"
                v-model="password"
                name="password"
                required
                autocomplete="current-password"
                autofocus
                placeholder="Contraseña"
              />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fa fa-lock" style="font-size: 20px"></span>
                </div>
              </div>
            </div>
            <div>
              <router-link
                to="recuperacion"
                style="text-decoration: none; font-weight: 700; font-size: 13px"
                ><p>¿Olvidaste tu contraseña?</p></router-link
              >
            </div>
            <button type="submit" class="btn btn-secondary" :disabled="loading || isLocked">
              Ingresar
            </button>
          </form>
          <div v-if="loading" class="spinner-overlay">
            <div
              class="spinner-border text-primary"
              style="width: 3rem; height: 3rem"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer-container">
      <div class="social-links">
        <a
          href="https://www.instagram.com/baesshmx/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          class="social-link"
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/baesshsc/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          class="social-link"
        >
          <i class="fab fa-facebook"></i>
        </a>
        <a
          href="https://wa.me/526677138632"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          class="social-link"
        >
          <i class="fab fa-whatsapp"></i>
        </a>
      </div>
      <div class="footer-links">
        <a
          href="https://www.baessh.com.mx"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
        >
          Visita nuestro sitio web
        </a>
        <a
          href="https://wa.me/526677138632"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
        >
          ¿Necesitas ayuda?
        </a>
      </div>
      <div class="footer-brand">
        <img
          src="../assets/logobaesshmono.svg"
          alt="Logo BAESSH monocromático"
          class="footer-brand-logo"
        />
        <span class="footer-brand-name">
          Bufete de Asesoría Especializada en Salud, Seguridad e Higiene
          Laboral S.C. © 2026
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance, { setAccessToken } from "../services/axiosInstance";

export default {
  data() {
    return {
      rfc: "",
      password: "",
      errorMessage: "",
      lockedUntil: null,
      lockedCountdown: "",
      lockTimer: null,
      loading: false,
    };
  },
  name: "LoginPage",
  async created() {
    try {
      //Verificar si tiene token activo en cookies
      const { data } = await axiosInstance.get("/users/auth/refresh", {
        __skip401Handler: true,
      });
      setAccessToken(data.accessToken);
      const me = await axiosInstance.get("/users/me");
      localStorage.setItem("role", me.data.role);

      const destino = me.data.role == 1 ? "/home" : "/home-cap";
      if (this.$route.path !== destino) {
        this.$router.replace(destino);
      }
    } catch {
      //No hacer nadota
    }
  },
  methods: {
    parseLockedUntil(value) {
      if (!value) return null;

      const lockedUntil = new Date(value);
      return Number.isNaN(lockedUntil.getTime()) ? null : lockedUntil;
    },
    updateLockedCountdown() {
      if (!this.lockedUntil) {
        this.lockedCountdown = "";
        return;
      }

      const remaining = this.lockedUntil.getTime() - Date.now();
      if (remaining <= 0) {
        this.clearLockState();
        return;
      }

      const totalSeconds = Math.ceil(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      this.lockedCountdown = `${minutes}:${String(seconds).padStart(2, "0")}`;
    },
    startLockTimer() {
      this.stopLockTimer();
      this.updateLockedCountdown();

      if (this.lockedUntil) {
        this.lockTimer = window.setInterval(this.updateLockedCountdown, 1000);
      }
    },
    stopLockTimer() {
      if (this.lockTimer) {
        window.clearInterval(this.lockTimer);
        this.lockTimer = null;
      }
    },
    clearLockState() {
      this.lockedUntil = null;
      this.lockedCountdown = "";
      this.stopLockTimer();
    },
    handleLockedLogin(error) {
      const data = error.response?.data || {};
      this.errorMessage =
        data.message || "Cuenta bloqueada temporalmente. Intenta nuevamente más tarde.";
      this.lockedUntil = this.parseLockedUntil(data.locked_until);

      if (this.lockedUntil) {
        this.startLockTimer();
      } else {
        this.stopLockTimer();
        this.lockedCountdown = "";
      }
    },
    async iniciarSesion() {
      if (this.isLocked) return;

      this.loading = true; // Mostrar spinner
      try {
        const response = await axiosInstance.post("/users/login", {
          rfc: this.rfc,
          password: this.password,
        });

        // Si el login es exitoso
        localStorage.setItem("user", response.data.user.nombre);
        localStorage.setItem("role", response.data.user.role);

        setAccessToken(response.data.accessToken);

        // Redirige al usuario o capacitador segun sea el caso
        if (response.data.user.role == 1) {
          this.$router.push("/home");
        } else {
          this.$router.push("/home-cap");
        }
      } catch (error) {
        if (error.response?.status === 423) {
          this.handleLockedLogin(error);
          return;
        }

        this.clearLockState();
        this.errorMessage = "Credenciales incorrectas. Intenta nuevamente.";
      } finally {
        this.loading = false; // Ocultar spinner
      }
    },
  },
  computed: {
    isLocked() {
      return Boolean(this.lockedUntil && this.lockedUntil.getTime() > Date.now());
    },
  },
  beforeDestroy() {
    this.stopLockTimer();
  },
};
</script>

<style>
.body-main-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 1rem 1rem 1.5rem;
  background: linear-gradient(to left, #774d1b 14%, #182579 86%);
  overflow-x: hidden;
  overflow-y: auto;
}

.login-stage-container {
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-main-container {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2), -4px -4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.imagelogin-container {
  width: 40%;
}
.contentmain-container {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem 0;
}

.login-message-container {
  width: min(100%, 22rem);
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.login-error-message {
  width: 100%;
  max-height: 6.5rem;
  margin: 0;
  padding: 0.65rem 0.85rem;
  overflow-y: auto;
  font-size: 0.9rem;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.login-error-countdown {
  margin-top: 0.25rem;
  font-size: 0.84rem;
  font-weight: 600;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.login-footer-container {
  position: static;
  width: min(900px, 92vw);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  color: rgba(255, 255, 255, 0.493);
  text-align: center;
}

.social-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.social-link {
  color: rgba(255, 255, 255, 0.478);
  font-size: 1.4rem;
  transition: color 0.2s ease, transform 0.2s ease;
}

.social-link:hover,
.social-link:focus {
  color: rgba(255, 255, 255, 0.818);
  transform: translateY(-1px);
  text-decoration: none;
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.2rem;
  flex-wrap: wrap;
}

.footer-link {
  font-size: 0.97rem;
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
}

.footer-link:hover,
.footer-link:focus {
  color: rgba(255, 255, 255, 0.96);
  text-decoration: none;
}

.footer-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.footer-brand-logo {
  width: 1.50rem;
  opacity: 0.52;
}

.footer-brand-name {
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
}

@media (max-width: 950px) {
  .imagelogin-container {
    display: none;
  }
  .contentmain-container {
    width: 100%;
    padding: 1rem;
  }
  .login-main-container {
    width: 70%;
  }
  .body-main-container {
    padding-bottom: 1rem;
  }
  .login-footer-container {
    gap: 0.55rem;
  }
  .footer-links {
    gap: 1rem;
  }
  .footer-link {
    font-size: 0.88rem;
  }
  .footer-brand-name {
    font-size: 0.8rem;
    line-height: 1.35;
    max-width: 92vw;
  }
}

@media (max-width: 640px) {
  .login-main-container {
    width: 92%;
  }
  .social-link {
    font-size: 1.25rem;
  }
}
</style>
